import { Provider } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import { appReducer } from './services/app-service'
import AppContent from './ui/AppContent'

const appStore = configureStore({ reducer: appReducer })

const App = () => (
  <Provider store={appStore}>
    <AppContent />
  </Provider>
)

export default App
